<input
  class="checkbox-input horizontal"
  [ngClass]="{ 'is-box': withBox }"
  type="checkbox"
  [value]="value"
  [checked]="onChecked()"
  (change)="onModelChange($event)"
  (change)="onModelChange($event)"
  [id]="formLabel"
  [disabled]="disabled"
/>
<label
  [for]="formLabel"
  class="checkbox-container"
  [ngClass]="{ 'is-invalid': derrors && control.errors }"
>
  @if (label) {
    <span class="pr-input-label">
      {{ label }}
      @if (
        required ||
        (control &&
          control.validator &&
          control.validator({}) &&
          control.validator({}).required)
      ) {
        <em>*</em>
      }
    </span>
  }
  <ng-content></ng-content>
  <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
</label>
